import React, { Component } from 'react';
import _ from 'lodash';
import Logger from '../../util/Logger';
import Ideas from '../../models/Ideas';
import './CommentsDetailList.css';
import { commentApi } from "../../api/CommentApi";
import CommentCard from './CommentCard';

export default class CommentsDetailList extends Component {

  constructor (props) {
    super(props);
    const { idea } = props;
    if (!idea) {
      Logger.assert('Missing idea in CommentCard component');
    }
    this.state = {
      comments: []
    };
  }

  componentDidMount () {
    const { idea } = this.props;
    commentApi
      .getComments(Ideas.getId(idea))
      .then(comments => {
        this.setState({
          comments: comments
        })
      })
      .catch(error => {
        Logger.error("Error loading comments for idea ", idea, error);
      });
  }

  render () {
    return (
      <div className="comments-detail-list">
        {
          _.map(this.state.comments, (comment) => (
            !comment.deleted &&
            <div className="row comment">
              <div className="col-md-10">
                <CommentCard comment={comment}/>
              </div>
              <div className="col-md-1 pt-3 mr-0 pr-0">
                <i class="material-icons like">thumb_up</i> { comment.like_count }
              </div>
              <div className="col-md-1 pt-3 ml-0 pl-0">
                <i class="material-icons dislike">thumb_down</i> { comment.dislike_count }
              </div>
            </div>
          ))
        }
      </div>
    );
  }
}
